import type { FieldValues, Path, UseFormSetError } from 'react-hook-form';
import { ApiError } from '@shared/api';

export function applyApiFieldErrors<T extends FieldValues>(
  error: unknown,
  setError: UseFormSetError<T>,
): boolean {
  if (!(error instanceof ApiError)) return false;
  const entries = Object.entries(error.fieldErrors);
  if (entries.length === 0) return false;
  for (const [field, message] of entries) {
    setError(field as Path<T>, { type: 'server', message });
  }
  return true;
}
